import moment from "moment";
import { CurrencyDisplay, DataLoadingView } from "../../../../components";
import { appConfig } from "../../../../configs";
import { useAuth } from "../../../../hooks";
import { IViewSingleTransfer } from "../../../../interfaces-and-types";
import { getUserDepartment } from "../../../../utils";
import { transferStatus, transferTypes } from "../../../../enums";

export const ReceiptTemplate = (transfer: IViewSingleTransfer) => {
  const { active_tenant_id, staff_departments } = useAuth();
  const activeMerchantAccount = getUserDepartment(
    active_tenant_id,
    staff_departments
  );

  const isBankTransfer = transfer.transfer_type === transferTypes.bank;
  const recipientType = isBankTransfer ? "Bank" : "Gateway";
  const recipientAccountNoOrIdType = isBankTransfer ? "Acct." : "Handle";
  const recipientAccountOrMerchantName = isBankTransfer
    ? transfer.account_name
    : transfer.destination_gateway_merchant_name;
  const recipientAccountNoOrId = isBankTransfer
    ? transfer.account_number
    : transfer.destination_gateway_merchant_id;
  const recipientBankOrGatewayName = isBankTransfer
    ? transfer.bank_name
    : transfer.destination_gateway_name;
  // const recipientBankOrGatewayCode = isBankTransfer ? transfer.bank_code : transfer.destination_gateway_code

  const isFailed = transfer.status === transferStatus.failed;
  const isSuccessful = transfer.status === transferStatus.successful;

  const transferHeaderColor = isFailed
    ? "rgba(222, 30, 30, 0.2)"
    : "rgb(214 228 242)";

  if (!activeMerchantAccount)
    return <DataLoadingView message="Loading Transfer Receipt..." />;

  return (
    <div
      style={{
        minWidth: "300px",
        margin: "10px",
        padding: "2px",
        border: "2px solid rgb(214 228 242)",
        borderRadius: "3px",
      }}
    >
      <table style={{ width: "100%", backgroundColor: "rgb(244 244 244)" }}>
        <tbody>
          <tr
            style={{
              backgroundColor: transferHeaderColor,
            }}
          >
            <td style={{ textAlign: "center", padding: "10px 0" }}>
              <img
                src={`${process.env.PUBLIC_URL}/switchapp-logo.svg`}
                alt="switchapp logo"
                className="app-logo"
              />
            </td>
          </tr>
          <tr
            style={{
              backgroundColor: transferHeaderColor,
              fontSize: "12px",
              width: "100%",
            }}
          >
            <td
              style={{
                height: "50px",
                borderBottom: "1px solid lightgray",
                textAlign: "center",
              }}
            >
              <h4
                style={{
                  color: "#6c6464",
                  fontWeight: "bold",
                  padding: "10px 20px",
                }}
              >
                TRANSFER RECEIPT FOR
              </h4>
              <h1 style={{ color: "black", fontWeight: "bold" }}>
                {/* {transfer.currency} {transfer.amount} */}
                <CurrencyDisplay
                  amount={transfer.amount}
                  currencyOrSymbol={transfer.currency}
                  amountFontSize={30}
                  symbolFontSize={28}
                />
              </h1>
            </td>
          </tr>

          <tr>
            <td style={{ textAlign: "center" }}>
              <h6 style={{ margin: "20px 0", color: "gray" }}>
                TRANSFER DETAILS
              </h6>
            </td>
          </tr>

          <tr>
            <td>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Sender </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                            maxWidth: "250px",
                            textAlign: "right",
                          }}
                        >
                          {activeMerchantAccount.merchant_name.toUpperCase()}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Reference </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                            maxWidth: "250px",
                            textAlign: "right",
                          }}
                        >
                          {transfer.reference}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "24px", paddingRight: 0 }}>
                        <strong>Amount </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            lineHeight: "normal",
                          }}
                        >
                          <CurrencyDisplay
                            amount={transfer.amount}
                            currencyOrSymbol={transfer.currency}
                            amountFontSize={16}
                            symbolFontSize={12}
                          />
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Beneficiary </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          {recipientAccountOrMerchantName?.toUpperCase()}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Beneficiary {recipientType}</strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          {recipientBankOrGatewayName}
                        </span>
                      </p>
                    </td>
                  </tr>
                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>
                          Beneficiary {recipientAccountNoOrIdType}{" "}
                        </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          {recipientAccountNoOrId}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Session Id </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          {transfer.session_id || "---"}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                      borderBottom: "solid .2px rgba(222,221,221,.65)",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Description </strong>

                        <span
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            maxWidth: "250px",
                            textAlign: "right",
                          }}
                        >
                          {transfer.description?.toUpperCase()}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottom: "solid .2px rgba(222,221,221,.65)",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Transfer Date </strong>

                        <span style={{ float: "right", marginLeft: "10px" }}>
                          {transfer.status !== transferStatus.successful
                            ? "---"
                            : `${moment(transfer.paid_at).format(
                                appConfig.dateTimeFormat
                              )} UTC`}
                        </span>
                      </p>
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "rgb(226 232 236)",
                      fontSize: "12px",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 20px",
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                      }}
                    >
                      <p style={{ lineHeight: "20px", paddingRight: 0 }}>
                        <strong>Status </strong>

                        <strong
                          style={{
                            float: "right",
                            marginLeft: "10px",
                            color: `${isSuccessful ? "green" : "red"}`,
                          }}
                        >
                          {transfer.status?.toUpperCase()}
                        </strong>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
